import axiosInstance, { ExtendedAxiosRequestConfig } from 'api/axiosInstance';
import type { Currency } from 'types/global.types';
import {
  InstallmentAmountTypeEnum,
  InvoiceItem,
  InvoiceStatus,
  ProjectRevenue,
  VATSubtotals,
} from 'types/invoice.types';

const service = '/v3/revenues';

type GetRevenueNextItemsBody = {
  amount: number;
  amountType: InstallmentAmountTypeEnum;
  projectItems: InvoiceItem[];
  currency: Currency;
  baseCurrency: Currency;
};

export const getRevenueNextItems = (
  body: GetRevenueNextItemsBody,
  options?: ExtendedAxiosRequestConfig,
) => {
  return axiosInstance.post<any, { items: InvoiceItem[] }>(
    `${service}/projects/calculations/next-items`,
    body,
    options,
  );
};

export enum RevenueProjectStatus {
  completed = 'completed',
  in_progress = 'in_progress',
}

export type RawRevenueProject = {
  baseCurrency: string;
  currency: string;
  currencyRate: number;
  clientId: string;
  baseCurrencyTotalAmountExclVAT: number;
  baseCurrencyTotalAmountInclVAT: number;
  baseCurrencyTotalVATAmount: number;
  items: InvoiceItem[];
  revenues: (Omit<ProjectRevenue, 'revenueId'> & {
    revenueId: { _id: string; status: InvoiceStatus; dueDate: string };
  })[];
  VATSubtotals: VATSubtotals[];
  totalAmountExclVAT: number;
  totalAmountInclVAT: number;
  totalVATAmount: number;
  status: RevenueProjectStatus;
  _id: string;
};

export const getRevenueProjectById = (id: string) => {
  return axiosInstance
    .get<any, RawRevenueProject>(`${service}/projects/${id}`)
    .then((data) => {
      return {
        ...data,
        // TODO: remove after backend fix, this is just to prevent crashes
        // backend doesn't handle deleting revenues well
        revenues: data.revenues.filter((r) => r.revenueId),
      };
    });
};
